//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    imageUrl: String,
    caption: String,
    indent: {
      type: Boolean,
      default: true
    },
    isScalable: {
      type: Boolean,
      default: false
    },
    widthPercent: {
      type: Number,
      default: 100
    },
    centerAlign: {
      type: Boolean,
      default: false
    }
  }
}
